import { uploadFile } from "./uploadFile";

export const processUserWorksWithFile = async (props) => {
    // Respuesta que se entrega al final
    const response = { success: 0, data: [], message: "" };

    const { trabajos, registroReferencia } = props;

    // Para cada trabajo
    await trabajos.forEach(async (work, index) => {
        const { trabResumenFile } = work;
        const { file } = trabResumenFile;

        // Obtenemos la extension del archivo
        const ext = (file.name).slice( (file.name).lastIndexOf('.') + 1 );
        
        let fileName = `${ registroReferencia }-${ index + 1 }.${ ext }`;
        console.log(fileName);
        // Subir archivo
        const resultUpload = await uploadFile({file:trabResumenFile, fileName});
        console.log(resultUpload);
        // Si no se subio el archivo, regresa el mensaje de error
        if (resultUpload.exito !== 1) {
            response.message = resultUpload.message;
            return response;
        }
    });

    response.success = 1;
    response.data = trabajos;

    return response;
};
